
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import HeroSection from './components/HeroSection';
import ServicesSection from './components/ServicesSection';
import VehiclesSection from './components/VehiclesSection';
import DestinationSection from './components/DestinationSection';
import BookingSection from './components/BookingSection';
import ContactSection from './components/ContactSection';

export default function Home() {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      <main>
        <HeroSection />
        <ServicesSection />
        <VehiclesSection />
        <DestinationSection />
        <BookingSection />
        <ContactSection />
      </main>
      <Footer />
    </div>
  );
}
